import { themes } from '../../../themes';
import { colorsToKebab } from './colors-to-kebab';

export const createThemeContext = (theme: string) => ({
  theme,
  colors: themes[theme],
  colorsCamel: themes[theme] as Record<string, string>,
  colorsKebab: colorsToKebab(themes[theme]),
});
